<template>
  <div class="table-responsive">
    <table class="table table-sm bg-light">
      <thead class="t-head hh-t-head">
        <tr>
          <td></td>
          <td>Nr.</td>
          <td>Data</td>
          <td>Status</td>
          <td>User</td>
          <td>Pax</td>
          <td>Client</td>
          <td>Total de plata</td>
          <td>Platit</td>
          <td>Rest plata total</td>
          <td class="text-center">Scadenta finala</td>
        </tr>
      </thead>
      <tbody>
        <template v-for="(result, resIndex) in results">
          <BookingResult
            :booking="result"
            :key="'result' + resIndex"
            @view="$emit('view', result.id)"
            @editPassenger="$emit('editPassenger')"/>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import BookingResult from './booking_result'

export default {
  name: 'BookingSearchResults',
  props: ['results'],
  components: { BookingResult }
}
</script>
